//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p style="font-size:16px;">Блоки</p>
    <div v-if="(cmsBlocks != null)">
      <entity-manager :data="cmsBlocks" :options="cmsBlocksEntityManagerOptions" style="padding-top: 20px;">
        <template slot="dataItemFieldTableView" scope="viewProps">
          <span>
            {{viewProps.dataRow.val[viewProps.column.field]}}
          </span>
        </template>

        <template slot="dataItemFieldEditView" scope="viewProps">
          <span v-if="(viewProps.fieldKey == 'name') || (viewProps.fieldKey == 'belongsToRegion') || (viewProps.fieldKey == 'weight') || (viewProps.fieldKey == 'mode')">
            <Input v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" style="width:100%"></Input>
          </span>
          <span v-else-if="(viewProps.fieldKey == 'query')">
            {{viewProps.editingDataRow.val[viewProps.fieldKey]}}
            <InputJSON v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" rows="3"></InputJSON>
          </span>
          <span v-else-if="(viewProps.fieldKey == 'showOptions')">
            <InputJSON v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" rows="12"></InputJSON>
          </span>
          <span v-else style="width:100%; height: 26px">
            {{viewProps.editingDataRow.val[viewProps.fieldKey]}}
          </span>
        </template>
      </entity-manager>
    </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import EntityManager from '@/technical/components/EntityManager'

export default {
  data () {
    return {
      cmsBlocks: null,
      cmsBlocksEntityManagerOptions: {
        tableColumns: [
          {title: 'id', width: '40px', field: 'id'},
          {title: 'Название', width: '', field: 'name'},
          {title: 'Регион', width: '160px', field: 'belongsToRegion'},
          {title: 'Вес', width: '80px', field: 'weight'},
          {title: 'Mode', width: '160px', field: 'mode'}
        ],
        editorFields: {name: 'Название', belongsToRegion: 'Регион', weight: 'Вес', mode: 'Mode', query: 'Query', showOptions: 'Show options', id: 'id'},
        newEmptyEntity: function (thisRef) {
          let result = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsBlockResource)
          result.val = {}
          result.val.name = ''
          result.val.belongsToRegion = ''
          result.val.weight = 0
          result.val.query = 0
          result.val.showOptions = {}
          return result
        },
        commonDataReloadOptions: {},
        disableDelete: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'commonData'
    ])
  },
  components: { EntityManager },
  created: function () {
    var thisRef = this

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! это надо выносить в общий компонент читки статических данных с сервера и занесение их в store.CommonData
    var cmsBlocks = []
    var cmsBlockResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsBlockResource)
    cmsBlockResource.query()
    .then(function (response) {
      if (response.data == null) return serverErrorHandling('что-то не так', thisRef)
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var oneCMSBlockResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsBlockResource)
        oneCMSBlockResource.val = response.data[itemIndx]
        cmsBlocks.push(oneCMSBlockResource)
      }
      thisRef.cmsBlocks = cmsBlocks
    })
    .catch((error) => serverErrorHandling(error, thisRef))
  },
  methods: {
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




// WEBPACK FOOTER //
// Blocks.vue?321ffc9a